module.exports = __webpack_public_path__ + "img/4.e9cd95ff.png";